export function PageFooter() {
  return (
    <div className="fixed left-0 right-0 bottom-0 py-3 px-7 bg-rs-black border-t border-rs-jet flex items-center justify-between gap-[18px] flex-wrap z-[15]">
      <span className="text-[11.5px] text-rs-light-gray">© ResinSmart {new Date().getFullYear()}</span>
    </div>
  );
}
